import type { CardTagProps } from "features/daily-delivery/types";
import { getVariantColor } from "features/daily-delivery/utils";
import styled from "styled-components";

export const CardTag = styled.div<CardTagProps>`
  border: 1px solid ${({ variant }) => getVariantColor(variant)};
  border-radius: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 4px 8px;
  background-color: ${({ variant }) => getVariantColor(variant)};
`;
